
import React, { useState, Fragment } from 'react';
import { bool, element } from 'prop-types';

import { getGridConfig, getIcon } from './layout-two-vertical-grids-util.js';


const LayoutTwoVerticalGrids = ({ isExpanded, leftComponent, rightComponent }) => {
    const [isLeftGridCollapsed, setIsLeftGridCollapsed] = useState(isExpanded);

    const { leftGridWidth, rightGridWidth, leftContainerCss, rightContainerCss } = getGridConfig(isLeftGridCollapsed);
    const buildIcon = getIcon(setIsLeftGridCollapsed);

    return (
        <Fragment>
            { !isLeftGridCollapsed && <div className='row spark-pull-left' style={{width: `${leftGridWidth}%`}}><span className='icon-toggle icon-toggle--expand'>{buildIcon(isLeftGridCollapsed)}</span></div> }
            <div className='spark-pull-left' style={{width: `${rightGridWidth}%`}}>
                <div className='row'>
                    <div className={`${leftContainerCss} left-content`}>
                        <span className={`${isLeftGridCollapsed ? '' :  'spark-hidden'}`}>{leftComponent}</span>
                        <span className='icon-toggle icon-toggle--collapse'>{buildIcon(isLeftGridCollapsed)}</span>
                    </div>

                    <div className={`${rightContainerCss} right-content`}>{rightComponent}</div>
                </div>
            </div>
            <div className='spark-clear'>&nbsp;</div>
        </Fragment>
    )
};

LayoutTwoVerticalGrids.propTypes = {
    isExpanded: bool,
    leftComponent: element,
    rightComponent: element.isRequired
};

export default LayoutTwoVerticalGrids;
